// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
interface TocChild {
  title: string;
  content: string;
}

interface TocType {
  title: string;
  content: string;
  children: TocChild[];
}

export const TOC = [
  {
    title: '註冊登入問題',
    content: `Q1: 要如何進行註冊呢？
    A1: 註冊需於註冊頁面填寫入您的使用者名稱、信箱及欲設定之密碼後，請到信箱收取驗證信並點擊驗證，帶您回到頁面進行跳轉後顯示「Confirm!」即代表註冊成功。

    Q2: 為何我無法註冊或是註冊失敗呢？
    A2: 無法註冊時請檢查您是否都切換為半形英文字母或數字進行輸入，若有任何錯誤訊息出現，請依指示進行調整 ; 若您收不到驗證信，請確認你的 email 輸入無誤，同時確認垃圾信件夾是否收到驗證信，若都已確認，還未收到驗證信，請來信聯繫客服。

    Q3: 確認輸入正確帳密後，顯示網站為惡意網頁無法登入？
    A3: 若點擊網站連結出現夾帶惡意檔案導致無法進入課程，建議使用無痕視窗開啟連結，並以手動輸入網址來開啟網頁，即可順利進入課程介面。若依然無法登入，請來信聯繫客服。`,
    children: []
  }, {
    title: '回報問題機制',
    content: `Q1: 遇到問題該如何回報？
    A1: 您可以於平台頁面的右下角的「問題回報」提報問題，或是來信至 <a href="mailto:training@ecloudvalley.com" style="text-decoration: underline;">training@ecloudvalley.com</a> ，客服會與您聯繫解答。`,
    children: []
  }, {
    title: '完成度問題',
    content: `Q1: 要如何查看課程完成進度呢？
    A1: 請點選平台頁面左上角「我的學習」，即可查看各課程的總完成度。

    Q2: 我已觀看完影片，但顯示未完成，是什麼原因呢？
    A2: 您可以協助確認在課程觀看頁面中，每個章節影片皆已跳為觀看完成的綠底，幫助系統計算完成度，並要確認有完整的觀看過整部影片，才會顯示「已完成」。

    Q3: 我已操作完實驗/挑戰/考試，但顯示已結束，是什麼原因呢？
    A3: 
      1. 實驗的部分，要請您確認有將實驗的每個步驟都完整的做完，系統才會紀錄為已完成的狀態喔！
      2. 挑戰則是需要通過每一項 Task，系統才會顯示為已完成！
      3. 考試為通過合格分數後，您的實作紀錄即會顯示已完成！
    
    Q4: 要在哪裡查看每個實作是否有完成呢？
    A4: 您可以點選平台頁面左上角「我的學習」，在頁面中有實作紀錄的選項，可以再選擇要查看實驗/挑戰/考試的完成狀態喔！
    `,
    children: []
  }
] as unknown as TocType[];
